import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20moody%20editorial%20collage%20of%20blurred%20gossip%20magazine%20photos%20with%20torn%20paper%20layers%2C%20muted%20terracotta%20amber%20and%20deep%20brown%20palette%2C%20dramatic%20side%20lighting%2C%20stylized%20abstract%20composition%2C%20cinematic%20grain%2C%20no%20readable%20text&width=1600&height=900&seq=ahh-hero-main&orientation=landscape"
          alt="爱黑料网精选资源库大主视觉"
          title="爱黑料网合集与打包资源库"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/60"></div>
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-background-50"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-24 pt-[130px] text-center md:px-8 md:pb-28 md:pt-[190px]">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-50/90 backdrop-blur-sm md:text-sm">
          <span className="h-1.5 w-1.5 animate-soft-pulse rounded-full bg-accent-400"></span>
          今日已更新 128 条 · 常逛的人有 52.3 万
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-6xl">
          爱黑料网 · 合集与打包
          <span className="mx-2 text-accent-400">一站</span>
          收齐
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base">
          爱黑料网合集与打包资源集中呈现，精选图文集与黑料库一站获取。顺着时间线往下看，
          点开就能落到完整资源库，省去翻找时间，高效吃瓜。
        </p>

        <div className="mt-8 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
          <a
            href="#collections"
            className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-book-shelf-line text-base"></i>
            </span>
            进入资源库
          </a>
          <a
            href="#downloads"
            className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 bg-background-50/10 px-7 py-3.5 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-download-cloud-2-line text-base"></i>
            </span>
            打包下载入口
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-4 md:gap-6">
          {heroStats.map((stat) => (
            <div key={stat.id} className="flex flex-col items-center">
              <dd className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
                <span className="ml-0.5 text-sm font-normal text-background-50/70">{stat.unit}</span>
              </dd>
              <dt className="mt-1 text-xs text-background-50/70 md:text-sm">{stat.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}